module.exports = __webpack_public_path__ + "static/img/Lucas-Camporeale.b498a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lucas-Camporeale.jpg
// module id = N6EH
// module chunks = 0